import React, { useEffect, useState } from 'react'
import classes from './SenderDetail.module.scss';
import Button from 'shared/components/form-input/button/Button';
import { Close } from '@mui/icons-material';
import IconEdit from 'assets/icon/IconEdit';
import { useDispatch } from 'react-redux';
import EventRegister, { EVENT_SHOW_POPUP, EVENT_SHOW_UPDATE_SENDER_POPUP } from 'utils/EventRegister';
import useTrans from 'hooks/use-trans';
import { actionsHolonInstance } from 'redux/holon-instance/action';
import Constants from 'utils/Constants';
import IconChecked from 'assets/icon/IconChecked';
import IconCheck from 'assets/icon/IconCheck';
import moment from 'moment';
import WrapContentBody from '../custom-body/WrapContentBody';
import actionSender from 'redux/sender/action';
import useRouter from 'hooks/use-router';
import BoxContentPopup from '../custom-body/BoxContentPopup';
import Box from '../../box/Box';
import BoxHeader from '../../box/BoxHeader';
import BoxTitle from '../../box/BoxTitle';
import BoxBody from '../../box/BoxBody';
import BoxRow from '../../box/BoxRow';
import BoxContent from '../../box/BoxContent';
import BoxLabel from '../../box/BoxLabel';
import CommonValueAttributes from 'shared/components/form-input/common-value-attributes/CommonValueAttributes';

function SenderDetailPopup(props) {
    const { payload, showVisible } = props;
    const { t } = useTrans();
    const router = useRouter();
    const dispatch = useDispatch();
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [dataHolonInstanceDetail, setHolonInstanceDetail] = useState([]);
    const handleEdit = () => {
        EventRegister.emit(EVENT_SHOW_POPUP, {
            open: true,
            type: EVENT_SHOW_UPDATE_SENDER_POPUP,
            payload: {
                showHeader: false,
                customStyle: {
                    padding: 0,
                    borderTop: 0
                },
                title: t("sender.update_sender"),
                holonTemplateDetail: payload?.holonTemplateDetail,
                sender: payload?.sender,
            }
        })
    }

    useEffect(() => {
        if (payload?.holonTemplateDetail?.attributes?.length > 0 && payload?.sender.id) {
            setHolonInstanceDetail(payload?.holonTemplateDetail?.attributes?.map(x => {
                let indexDetail = payload?.sender.attributes?.findIndex(attribute => attribute.name == x?.key);
                return {
                    ...x,
                    [x?.key]: payload?.sender.attributes[indexDetail]?.value,
                    value: payload?.sender.attributes[indexDetail]?.value,
                    name: payload?.sender.attributes[indexDetail]?.name,
                }
            }))
        }
    }, [payload?.holonTemplateDetail, payload?.sender])

    const handleClose = () => {
        showVisible()
    }

    const onClose = () => {
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_DETAIL_SUCCESS,
            payload: {}
        })
    }

    const handleDelete = () => {
        setLoadingDelete(true);
        dispatch({
            type: actionSender.DELETE_SENDER,
            payload: payload?.sender?.id,
            callback: {
                success: () => {
                    dispatch({
                        type: actionSender.GET_SENDER_LIST,
                        payload: {
                            ...router.getAll()
                        }
                    })
                    handleClose();
                    setLoadingDelete(false);
                },
                failed: () => {
                    setLoadingDelete(false);
                }
            }
        })
    }

    return (
        <BoxContentPopup>
            <WrapContentBody
                title={payload?.title}
                actionSectionTop={<Button onClick={handleEdit} color='gray' startIcon={<IconEdit color="currentColor" />} />}
                actionSectionBottom={<Button loading={loadingDelete} onClick={handleDelete} title={t("Holon_Template.delete")} />}
            >
                <div className={classes['Wrap-Content']}>
                    <div className={classes['FormHas']}>
                        <Box>
                            <BoxHeader>
                                <BoxTitle>
                                    {t("sender.basic_information")}
                                </BoxTitle>
                            </BoxHeader>
                            <BoxBody>
                                {
                                    dataHolonInstanceDetail?.map((x, key) => {
                                        return <BoxRow key={key}>
                                            <BoxLabel minWidth="140px">
                                                {x?.label}
                                            </BoxLabel>
                                            <BoxContent>
                                                <CommonValueAttributes x={x} />
                                            </BoxContent>
                                        </BoxRow>
                                    })
                                }
                            </BoxBody>
                        </Box>
                    </div>
                </div>
            </WrapContentBody>
        </BoxContentPopup>
    )
}

export default SenderDetailPopup